export default __webpack_public_path__ + "static/media/CAFFENIO.9d8871fa.svg";